var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.00019H3.41L6.71 2.71019C6.8983 2.52188 7.00409 2.26649 7.00409 2.00019C7.00409 1.73388 6.8983 1.47849 6.71 1.29019C6.5217 1.10188 6.2663 0.996094 6 0.996094C5.7337 0.996094 5.4783 1.10188 5.29 1.29019L0.289999 6.29019C0.198959 6.38529 0.127594 6.49743 0.0799993 6.62019C-0.0200187 6.86365 -0.0200187 7.13672 0.0799993 7.38019C0.127594 7.50294 0.198959 7.61508 0.289999 7.71019L5.29 12.7102C5.38296 12.8039 5.49356 12.8783 5.61542 12.9291C5.73728 12.9798 5.86799 13.006 6 13.006C6.13201 13.006 6.26272 12.9798 6.38458 12.9291C6.50644 12.8783 6.61704 12.8039 6.71 12.7102C6.80373 12.6172 6.87812 12.5066 6.92889 12.3848C6.97966 12.2629 7.0058 12.1322 7.0058 12.0002C7.0058 11.8682 6.97966 11.7375 6.92889 11.6156C6.87812 11.4937 6.80373 11.3831 6.71 11.2902L3.41 8.00019H11C11.2652 8.00019 11.5196 7.89483 11.7071 7.70729C11.8946 7.51976 12 7.2654 12 7.00019C12 6.73497 11.8946 6.48062 11.7071 6.29308C11.5196 6.10554 11.2652 6.00019 11 6.00019Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUPrevious);
export default __webpack_public_path__ + "static/media/U_previous.5fda77536bed679b2f8db7e7c2a87fdc.svg";
export { ForwardRef as ReactComponent };